module.exports = __webpack_public_path__ + "img/Elektrische schema's.74900f27.svg";